import React from 'react';
import styles from '../shared/TipComponents.module.scss';

/*Components */
import { ProductContainer } from '../../../shared/components/ProductContainer/ProductContainer';
import { TipHeader } from '../../components/TipHeader/TipHeader';
import { TipBox } from '../../components/TipBox/Box/TipBox';
import { TipCouponInfo } from '../../components/TipCouponInfo/TipCouponInfo';
import { TipAnalysisBoxConnected } from '../../components/TipAnalysisBox/TipAnalysisBox';
import { UnlockedTipBoxTopConnected } from '../../components/TipBox/Top/UnlockedTipBoxTop';

/* Interfaces */
import { PremiumTipProduct, Tipster } from '../../interfaces/TipProduct';

interface PremiumTipProps {
  tipster: Tipster;
  tip: PremiumTipProduct;
}

export const PurchasedPremiumTipComponent: React.FC<PremiumTipProps> = ({
  tipster,
  tip,
}) => {
  return (
    <>
      <ProductContainer>
        <div className={styles.container}>
          <TipHeader type={tip.priceType} />

          <TipBox>
            <UnlockedTipBoxTopConnected />
          </TipBox>

          <TipCouponInfo />
        </div>
      </ProductContainer>

      <TipAnalysisBoxConnected />
    </>
  );
};
